import loadable from '@loadable/component'
import {getRouter} from 'hiya-common/src/routes'

import anchorcenter from './anchorcenter'
import chat from './chat'
import coinagency from './coinagency'
import crossRoomPk from './crossRoomPk'
import feedback from './feedback'
import game from './game'
import giftBook from './giftBook'
import guildSettled from './guildSettled'
import Helping from './Helping'
import hunting from './hunting'
import loginQuestion from './loginQuestion'
import union from './union'
import virtual from './virtual'
import wallet2 from './wallet2'
import cardMixture from './cardMixture'
import medal from './medal'
import staticPage from './static'
import temporaryPage from './temporaryPage'
import TikTok from './TikTok'
import blindBox from './blindBox' // 盲盒
import family from './family' // 家族
import walletAdvanced from './walletAdvanced'
import walletPure from './walletPure'
import wealthLevel from './wealthLevel'
import coiner from './coiner'

const routes = getRouter([
  ...TikTok,
  ...medal,
  {
    path: '/LuckyGift',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LuckyGift" */ '~/pages/LuckyGift')
    ),
  },
  ...wallet2,
  ...virtual,
  {
    path: '/SnatchSingPlay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SnatchSingPlay" */ '~/pages/SnatchSingPlay'
        )
    ),
  },
  {
    path: '/UnionPK',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UnionPK" */ '~/pages/UnionPK')
    ),
  },
  {
    path: '/newbigr',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-NewBIgR" */ '~/pages/NewBIgR')
    ),
  },
  ...game,
  {
    path: '/GeneralLottery',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GeneralLottery" */ '~/pages/GeneralLottery'
        )
    ),
  },
  {
    path: '/bigr',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-BigR" */ '~/pages/BigR')
    ),
  },
  {
    path: '/Share',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Share" */ '~/pages/Share')
    ),
  },
  {
    path: '/unionTask',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UnionTask" */ '~/pages/UnionTask')
    ),
  },
  {
    path: '/unionTask3',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-UnionTask3" */ '~/pages/UnionTask3')
    ),
  },
  {
    path: '/unionTask3/rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionTask3-rank" */ '~/pages/UnionTask3/Rank'
        )
    ),
  },
  {
    path: '/doubleroomtask',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTask" */ '~/pages/DoubleRoomTask'
        )
    ),
  },
  {
    path: '/doubleroomtask/recruit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTaskRecruit" */ '~/pages/DoubleRoomTask/recruit'
        )
    ),
  },
  {
    path: '/doubleroomtask/board',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DoubleRoomTask-board" */ '~/pages/DoubleRoomTask/board'
        )
    ),
  },
  {
    path: '/send',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Send" */ '~/pages/Send')
    ),
  },
  {
    path: '/UserInfoCollection',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UserInfoCollection" */ '~/pages/UserInfoCollection'
        )
    ),
  },
  {
    path: '/AnchorTaskSystem',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorTaskSystem" */ '~/pages/AnchorTaskSystem'
        )
    ),
  },
  // {
  //   // 贵族/体验贵族 领取页
  //   path: '/NormalVipActive',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-NormalVipActive" */ '~/pages/NormalVipActive'
  //       )
  //   ),
  // },
  {
    // 自动跳转udesk
    path: '/Udesk',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-GoUdesk" */ '~/pages/GoUdesk')
    ),
  },
  // otherInfo携带邀请公会id m_union_id
  {
    path: '/Talent/invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentApply-invitation" */ '~/pages/TalentApply/invitation'
        )
    ),
  },
  {
    path: '/TalentApply',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-TalentApply" */ '~/pages/TalentApply')
    ),
  },
  {
    // 用户任务，签到中心
    path: '/UserTasks',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-UserTasks" */ '~/pages/UserTasks')
    ),
  },
  {
    // 用户任务，全局弹窗
    path: '/UserTasks/Modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UserTasks-Modal" */ '~/pages/UserTasks/Modal'
        )
    ),
  },
  ...chat,
  ...feedback,
  ...hunting,
  ...coinagency,
  ...crossRoomPk,
  ...union,
  ...Helping,
  ...anchorcenter,
  ...loginQuestion,
  ...guildSettled,
  ...giftBook,
  ...cardMixture,
  ...staticPage,
  ...temporaryPage, // 一些和版本有关的页面，后续可直接删掉
  ...blindBox, // 盲盒
  ...family, // 家族
  ...walletAdvanced,
  ...walletPure,
  ...wealthLevel,
  ...coiner,
])

export default (store) => routes
